import SidePanel from '@ui/Accommodation/SidePanel/component'
import type { SidePanelType } from '@ui/SidePanel/component'

export const createSidePanel = (id: string, url: string, type: 'accommodation' | 'pitch', accommodationId: string): SidePanelType | undefined => {
  return SidePanel(id, url, type, accommodationId)
}
